import {Component, effect, inject, OnInit, Signal} from '@angular/core';
import {Router, RouterModule} from '@angular/router';
import {MatIconModule} from '@angular/material/icon';
import {MatButtonModule} from '@angular/material/button';

import {ClpFormatPipe} from '@shared/pipes/clp/clp-format-pipe';
import {NgStyle} from '@angular/common';
import {FoodItem} from '@core/models';
import {BgUrlPipe} from '@shared/pipes/bg-url/bg-url-pipe';
import {CatalogStore} from '@store/catalog.store';
import {CartStore} from '@store/cart.store';

@Component({
  selector: 'app-product-detail',
  imports: [RouterModule, MatIconModule, MatButtonModule, ClpFormatPipe, NgStyle, BgUrlPipe],
  templateUrl: './product-detail.html',
  styleUrl: './product-detail.scss',
})
export class ProductDetail implements OnInit {

  protected readonly cartStore = inject(CartStore);
  private readonly store = inject(CatalogStore);
  protected readonly product: Signal<FoodItem | null> = this.store.product;
  private readonly router = inject(Router);

  constructor() {
    effect(() => {
      if (!this.product()) {
        this.router.navigate(['/standard/categories'], {replaceUrl: true});
      }
    });
  }

  ngOnInit() {
  }

  addToCart(item: FoodItem, event?: Event) {
    if (event) event.stopPropagation();
    this.cartStore.addToCart(item);
  }

}
